<template>
  <div class="edit-container">
    <form class="edit-form" @submit.prevent="submitForm">
      <h3 class="form-title">
        {{
          isEditMode ? "Редактирование шаблона" : "Создание шаблона"
        }}
      </h3>

      <div class="form-body">
        <div class="form-group" v-if="!isEditMode">
          <base-label :required="true">Тип документа</base-label>
          <base-select
            v-model="form.kind"
            :options="templateKindOptions"
            placeholder="Выберите тип документа"
            :clearable="false"
            :class="{ 'is-invalid': errors.kind }"
            @change="clearError('kind')"
          />
          <span v-if="errors.kind" class="error-text">
            Это поле обязательно
          </span>
        </div>

        <div class="form-group">
          <base-label :required="true">Название</base-label>
          <base-input
            v-model="form.name"
            type="text"
            required
            class="form-input"
            :class="{ 'is-invalid': errors.name }"
            @input="clearError('name')"
            @click="clearError('name')"
            placeholder="Введите название шаблона"
          />
          <span v-if="errors.name" class="error-text">
            Это поле обязательно
          </span>
        </div>

        <div class="form-group">
          <base-label>Описание</base-label>
          <base-textarea
            v-model="form.description"
            class="form-input"
            rows="3"
            placeholder="Краткое описание назначения шаблона"
          ></base-textarea>
        </div>
      </div>

      <div class="form-actions">
        <base-primary-button
          class="form-btn"
          type="submit"
          :loading="isLoading"
        >
          Сохранить
        </base-primary-button>
        <base-button
          class="form-btn"
          type="button"
          @click="$emit('cancel')"
        >
          Отмена
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useTemplateStore } from "@/stores/templateStore";

export default {
  name: "TemplateEditForm",
  props: {
    initialData: {
      type: Object,
      default: null,
    },
    companyId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
        kind: null,
      },
      errors: {
        name: false,
        kind: false,
      },
    };
  },
  computed: {
    ...mapState(useTemplateStore, [
      "isLoading",
      "templateKindOptions",
    ]),
    isEditMode() {
      return !!this.initialData && !!this.initialData.id;
    },
  },
  mounted() {
    if (this.initialData) {
      this.form = { ...this.initialData };
    }
  },
  methods: {
    ...mapActions(useTemplateStore, [
      "createTemplate",
      "updateTemplate",
    ]),

    validate() {
      let isValid = true;
      this.errors = { name: false, kind: false };

      if (!this.form.name || !String(this.form.name).trim()) {
        this.errors.name = true;
        isValid = false;
      }

      if (!this.isEditMode && !this.form.kind) {
        this.errors.kind = true;
        isValid = false;
      }

      return isValid;
    },

    clearError(field) {
      this.errors[field] = false;
    },

    async submitForm() {
      if (!this.validate()) return;

      try {
        if (this.isEditMode) {
          await this.updateTemplate(this.form.id, this.form);
        } else {
          await this.createTemplate(this.form);
        }
        this.$emit("save");
      } catch (error) {
        console.error("Ошибка сохранения шаблона:", error);
      }
    },
  },
};
</script>

<style scoped>
.edit-container {
  display: flex;
  flex-direction: column;
}

.form-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  margin-bottom: 0;
}

.form-input {
  width: 100%;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 25px;
  justify-content: flex-start;
}

.is-invalid {
  border-color: var(--color-danger);
}

.error-text {
  color: var(--color-danger);
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

@media (max-width: 480px) {
  .form-actions {
    flex-direction: column;
  }

  .form-btn {
    width: 100%;
  }
}
</style>
